import { render } from "./EventCard.vue?vue&type=template&id=34b2abcc&scoped=true"
import script from "./EventCard.vue?vue&type=script&lang=js"
export * from "./EventCard.vue?vue&type=script&lang=js"

import "./EventCard.vue?vue&type=style&index=0&id=34b2abcc&scoped=true&lang=css"

import exportComponent from "C:\\Users\\erwin\\Dropbox\\My Projects\\JavaScript\\Vue\\vuemastery\\real-world-vue-3\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-34b2abcc"]])

export default __exports__